"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _omit = _interopRequireDefault(require("lodash/omit"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactMomentProptypes = _interopRequireDefault(require("react-moment-proptypes"));

var _reactDates = require("react-dates");

require("react-dates/initialize");

require("react-dates/lib/css/_datepicker.css");

var _dates = require("../Utils/dates");

require("./css/DatePicker.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DateRangePickerWrapper = /*#__PURE__*/function (_Component) {
  _inherits(DateRangePickerWrapper, _Component);

  var _super = _createSuper(DateRangePickerWrapper);

  function DateRangePickerWrapper() {
    var _this;

    _classCallCheck(this, DateRangePickerWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      focusedInput: null,
      startDate: null,
      endDate: null
    });

    return _this;
  }

  _createClass(DateRangePickerWrapper, [{
    key: "handleDateChange",
    value: function handleDateChange(_ref) {
      var startDate = _ref.startDate,
          endDate = _ref.endDate;
      this.setState({
        startDate: startDate,
        endDate: endDate
      });
      this.props.onChange((0, _dates.parseDate)(startDate, {
        startOfDay: true
      }), (0, _dates.parseDate)(endDate, {
        endOfDay: true
      }));
    }
  }, {
    key: "handleFocusChange",
    value: function handleFocusChange(focusedInput) {
      this.setState({
        focusedInput: focusedInput
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          endDate = _this$state.endDate,
          startDate = _this$state.startDate,
          focusedInput = _this$state.focusedInput;
      var props = (0, _omit["default"])(this.props, ['disable', 'onChange']);
      return /*#__PURE__*/_react["default"].createElement(_reactDates.DateRangePicker // eslint-disable-next-line react/jsx-props-no-spreading
      , _extends({}, props, {
        startDate: startDate,
        endDate: endDate,
        focusedInput: focusedInput,
        isOutsideRange: function isOutsideRange(day) {
          return (0, _dates.isDayOutsideRange)(day, _this2.props.disable);
        },
        onDatesChange: function onDatesChange(change) {
          return _this2.handleDateChange(change);
        },
        onFocusChange: function onFocusChange(focus) {
          return _this2.handleFocusChange(focus);
        }
      }));
    }
  }]);

  return DateRangePickerWrapper;
}(_react.Component);

exports["default"] = DateRangePickerWrapper;

_defineProperty(DateRangePickerWrapper, "propTypes", {
  disable: _propTypes["default"].shape({
    before: _reactMomentProptypes["default"].momentObj,
    after: _reactMomentProptypes["default"].momentObj
  }),
  startDateId: _propTypes["default"].string,
  endDateId: _propTypes["default"].string,
  hideKeyboardShortcutsPanel: _propTypes["default"].bool,
  firstDayOfWeek: _propTypes["default"].number,
  small: _propTypes["default"].bool,
  withPortal: _propTypes["default"].bool,
  onChange: _propTypes["default"].func.isRequired
});

_defineProperty(DateRangePickerWrapper, "defaultProps", {
  startDateId: 'startDate',
  endDateId: 'endDate',
  hideKeyboardShortcutsPanel: true,
  firstDayOfWeek: 1,
  small: true,
  withPortal: true
});